import axios from '@/utils/request';
const v1 = 'v1/admin/mvms';

export const getMvms = (data) => axios.get(`${v1}/index`, data);
export const getMvm = (id) => axios.get(`${v1}/mvm`, { params: { id } });
export const getMvmsStatus = (data) => axios.get(`${v1}/status`, data);
export const search = (data) => axios.post(`${v1}/search`, data);
export const updateMvm = (data) => axios.post(`${v1}/update`, data);
export const updateDvm = (data) => axios.put(`${v1}/dvm`, data);
export const updateHardwareGateNumbers = (data) => axios.put(`${v1}/dvms/hardware-gates`, data);
export const createMvm = (data) => axios.post(`${v1}/create`, data);
export const deleteMvm = (data) => axios.post(`${v1}/delete`, data);
export const userMvms = () => axios.get(`${v1}/user/mvms`);
export const getMvmModels = () => axios.get(`${v1}/mvmModels`);
export const mvmNotDeployed = () => axios.get(`${v1}/notDeployed`);
export const getMvmsByCom = (data) => axios.post(`${v1}/byCom`, data);
export const getMvmsByUser = (data) => axios.post(`${v1}/byUser`, data);

export const getMvmSelect = ({ company_id = 1, client_id = null, user_id = null, show_all_mvm = false }) => axios.get(`${v1}/select`, { params: { company_id, client_id, user_id, show_all_mvm } });

export const getMvmNotRegist = ({ company_id = 1, client_id = null, user_id = null, version = '3', op_locate_id = null }) =>
  axios.get(`${v1}/notRegist`, {
    params: { company_id, client_id, user_id, version, op_locate_id },
  });
